import React, { useEffect, useState } from "react";
import Text from "components/Text";
import RadioInput from "components/RadioInput";
import { Row, Column } from "components/Layout/Grid";
import Validator from "components/Validator";
import DomainSettingService from "services/domainSetting.service";
import { IDomainSetting } from "models/DomainSetting";
import '../styles.scss';
import { ISampleType } from "./interface";

const SampleType: React.FC<ISampleType> = (props) => {
  const {
    protocolCategory,
    sampleType,
    setSampleType,
    isEditing
  } = props;
  const [sampleButtonsTypes, setSampleButtonsTypes] = useState(
    Array<IDomainSetting>()
  );

  const _domainSettingService = new DomainSettingService();

  useEffect(() => {
    _domainSettingService
      .get(undefined, undefined, undefined, {
        and: [
          { identifier: { eq: "TicketSampleType" } },

          { enabled: { eq: true } },
        ],
      })
      .then((result: any) => {
        if (result && result.data) {
          let _sampleButtonTypes: Array<IDomainSetting> = result.data;

          setSampleButtonsTypes(_sampleButtonTypes);
        }
      });
  }, []);

  useEffect(() => {
    if (!isEditing) {
      setSampleType('');
    }
  }, [protocolCategory]);

  return (
    <Column className="mt-5 flex-1">
      <Text className="mb-2 color-blue-gray" size={12}>
        Tipo de amostra
      </Text>
      <Validator value={sampleType} name="Tipo de amostra" required>
        <Row className="flex-md-column">
          {sampleButtonsTypes.map((el, index) => (
            <Row key={index} className="w-md-100 mt-md-2 mr-4">
              <RadioInput
                id={el.key}
                onClick={() => setSampleType(el.description ?? '')}
                checked={sampleType === el.description}
              >
                <Text className="color-blue-gray first-letter-uppercase">{el.description}</Text>
              </RadioInput>
            </Row>
          ))}
        </Row>
      </Validator>
    </Column>
  );
};

export default SampleType;
